<template>
  <div>
    <under-text-sxs>
      <div slot="underline">{{ proficiencyBonus }}</div>
      Proficiency Bonus
    </under-text-sxs>

    <under-text-sxs>
      <div slot="underline">{{ saveDc() }}</div>
      Spell / Feature Save DC
    </under-text-sxs>

    <under-text-sxs>
      <div slot="underline">
        <ez-modal-dice slot="underline" name="Spell Attack Bonus" :dice="`1d20+${spellBonus()}`">
          {{ spellBonus() }}
        </ez-modal-dice>
      </div>
      Spell / Feature Attack Bonus
    </under-text-sxs>

    <div class="row">
      <div class="col col-2">

      </div>
      <div class="col">
        <under-select v-model="item.core.spellCastingAttribute" :options="spellAbilityOptions">
          Spell / Feature Ability
        </under-select>
      </div>
    </div>

    <under-text-area-md v-model="item.core.languages" rows="2">
      Languages
    </under-text-area-md>

    <under-text-area-md v-model="item.core.proficiencies" rows="6">
      Proficiencies
    </under-text-area-md>
  </div>
</template>

<script>
import EzModalDice from "@/components/shared/_VueEzModalDice.vue";
import UnderInputSxs from "../shared/_UnderInputSxs.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import UnderTextSxs from "../shared/_UnderTextSxs.vue";
import UnderTextAreaMd from "../shared/_UnderTextAreaMd.vue";

export default {
  name: "sections-base-values-fifth-edtion",
  components: {
    EzModalDice,
    UnderInputSxs,
    UnderSelect,
    UnderTextSxs,
    UnderTextAreaMd
  },
  props: ["item"],
  data() {
    return {
      spellAbilityOptions: [
        { text: "", value: "" },
        { text: "Strength", value: "strength" },
        { text: "Dexterity", value: "dexterity" },
        { text: "Constitution", value: "constitution" },
        { text: "Intelligence", value: "intelligence" },
        { text: "Wisdom", value: "wisdom" },
        { text: "Charisma", value: "charisma" }
      ]
    };
  },
  computed: {
    proficiencyBonus() {
      return this.$rpgv.d20.proficiencyBonus(this.item.core.experience);
    }
  },
  methods: {
    // character: state => state.eb.character,
    spellBonus() {
      let attribute = this.$rulesets[this.item.ruleset].getAttribute(
        this.item.core.spellCastingAttribute,
        this.item.attributes
      );

      if (this.item) {
        return this.$rulesets[this.item.ruleset].getSpellBonus(
          this.proficiencyBonus,
          attribute
        );
      }
    },
    saveDc() {
      let bonus = 8 + this.spellBonus();
      return bonus;
    }
  }
};
</script>
